import React from 'react';
import PropTypes from 'prop-types';
import RadioField from './RadioField';

var YesNoField = function YesNoField(_ref) {
  var name = _ref.name,
      label = _ref.label,
      onChange = _ref.onChange;
  return React.createElement('div', {
    className: 'form-group'
  }, React.createElement('label', {
    className: 'control-label'
  }, label), React.createElement(RadioField, {
    onChange: onChange,
    name: name,
    label: 'Yes',
    value: 'yes'
  }), React.createElement(RadioField, {
    onChange: onChange,
    name: name,
    label: 'No',
    value: 'no'
  }));
};

YesNoField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func
};
export default YesNoField;